module.exports = __webpack_public_path__ + "img/1.9e05f7e8.png";